/* eslint-disable */
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipApi = void 0;
var http_1 = require("@wix/ambassador/runtime/http");
var MembershipApi = function (baseUrl, httpClientConfig) {
    var httpClient = new http_1.AmbassadorHTTPClient(baseUrl, httpClientConfig);
    return {
        CheckoutService: function () {
            return function (headers) {
                var service = {
                    applyCoupon: function (applyCouponRequest) {
                        return httpClient.invoke('POST', '/v2/checkout/orders/{order_id}/apply-coupon', applyCouponRequest, headers);
                    },
                    changeStartDate: function (changeStartDateRequest) {
                        return httpClient.invoke('PATCH', '/v2/checkout/orders/order/{order_id}', changeStartDateRequest, headers);
                    },
                    createOfflineOrder: function (createOfflineOrderRequest) {
                        return httpClient.invoke('POST', '/v2/checkout/orders/offline', createOfflineOrderRequest, headers);
                    },
                    createOnlineOrder: function (createOnlineOrderRequest) {
                        return httpClient.invoke('POST', '/v2/checkout/orders/online', createOnlineOrderRequest, headers);
                    },
                    getOfflineOrderPreview: function (getOfflineOrderPreviewRequest) {
                        return httpClient.invoke('POST', '/v2/checkout/orders/preview-offline', getOfflineOrderPreviewRequest, headers);
                    },
                    getOnlineOrderPreview: function (getOnlineOrderPreviewRequest) {
                        return httpClient.invoke('POST', '/v2/checkout/orders/preview-online', getOnlineOrderPreviewRequest, headers);
                    },
                    getPricePreview: function (v2OrdersGetPricePreviewRequest) {
                        return httpClient.invoke('POST', '/v2/checkout/orders/price-preview', v2OrdersGetPricePreviewRequest, headers);
                    },
                };
                service.applyCoupon.__http_method = 'POST';
                service.applyCoupon.__http_url = '/v2/checkout/orders/{order_id}/apply-coupon';
                service.changeStartDate.__http_method = 'PATCH';
                service.changeStartDate.__http_url = '/v2/checkout/orders/order/{order_id}';
                service.createOfflineOrder.__http_method = 'POST';
                service.createOfflineOrder.__http_url = '/v2/checkout/orders/offline';
                service.createOnlineOrder.__http_method = 'POST';
                service.createOnlineOrder.__http_url = '/v2/checkout/orders/online';
                service.getOfflineOrderPreview.__http_method = 'POST';
                service.getOfflineOrderPreview.__http_url = '/v2/checkout/orders/preview-offline';
                service.getOnlineOrderPreview.__http_method = 'POST';
                service.getOnlineOrderPreview.__http_url = '/v2/checkout/orders/preview-online';
                service.getPricePreview.__http_method = 'POST';
                service.getPricePreview.__http_url = '/v2/checkout/orders/price-preview';
                return service;
            };
        },
        OfflinePurchaseHelperService: function () {
            return function (headers) {
                var service = {
                    getOrCreateMemberByContactId: function (getOrCreateMemberByContactIdRequest) {
                        return httpClient.invoke('POST', '/v1/offline/get-or-create-member', getOrCreateMemberByContactIdRequest, headers);
                    },
                };
                service.getOrCreateMemberByContactId.__http_method = 'POST';
                service.getOrCreateMemberByContactId.__http_url = '/v1/offline/get-or-create-member';
                return service;
            };
        },
        OrderCommentsService: function () {
            return function (headers) {
                var service = {
                    createOrderComment: function (createOrderCommentRequest) {
                        return httpClient.invoke('POST', '/v1/orders/{orderId}/comments', createOrderCommentRequest, headers);
                    },
                    deleteOrderComment: function (deleteOrderCommentRequest) {
                        return httpClient.invoke('DELETE', '/v1/orders/{orderId}/comments/{id}', deleteOrderCommentRequest, headers);
                    },
                    getOrderComment: function (getOrderCommentRequest) {
                        return httpClient.invoke('GET', '/v1/orders/{orderId}/comments/{id}', getOrderCommentRequest, headers);
                    },
                    listOrderComments: function (listOrderCommentsRequest) {
                        return httpClient.invoke('GET', '/v1/orders/{orderId}/comments', listOrderCommentsRequest, headers);
                    },
                    updateOrderComment: function (updateOrderCommentRequest) {
                        return httpClient.invoke('PUT', '/v1/orders/{orderId}/comments/{id}', updateOrderCommentRequest, headers);
                    },
                };
                service.createOrderComment.__http_method = 'POST';
                service.createOrderComment.__http_url = '/v1/orders/{orderId}/comments';
                service.deleteOrderComment.__http_method = 'DELETE';
                service.deleteOrderComment.__http_url = '/v1/orders/{orderId}/comments/{id}';
                service.getOrderComment.__http_method = 'GET';
                service.getOrderComment.__http_url = '/v1/orders/{orderId}/comments/{id}';
                service.listOrderComments.__http_method = 'GET';
                service.listOrderComments.__http_url = '/v1/orders/{orderId}/comments';
                service.updateOrderComment.__http_method = 'PUT';
                service.updateOrderComment.__http_url = '/v1/orders/{orderId}/comments/{id}';
                return service;
            };
        },
        OrderManagementService: function () {
            return function (headers) {
                var service = {
                    cancelOrder: function (v2OrdersCancelOrderRequest) {
                        return httpClient.invoke('POST', '/v2/orders/{id}/cancel', v2OrdersCancelOrderRequest, headers);
                    },
                    getAvailableOrderActions: function (getAvailableOrderActionsRequest) {
                        return httpClient.invoke('GET', '/v2/orders/{id}/available-owner-actions', getAvailableOrderActionsRequest, headers);
                    },
                    getOrder: function (v2OrdersGetOrderRequest) {
                        return httpClient.invoke('GET', '/v2/orders/{id}', v2OrdersGetOrderRequest, headers);
                    },
                    getOrdersStats: function (v2OrdersGetOrdersStatsRequest) {
                        return httpClient.invoke('GET', '/v2/orders/stats', v2OrdersGetOrdersStatsRequest, headers);
                    },
                    listOrders: function (v2OrdersListOrdersRequest) {
                        return httpClient.invoke('GET', '/v2/orders', v2OrdersListOrdersRequest, headers);
                    },
                    markAsPaid: function (markAsPaidRequest) { return httpClient.invoke('POST', '/v2/orders/{id}/mark-as-paid', markAsPaidRequest, headers); },
                    pauseOrder: function (pauseOrderRequest) { return httpClient.invoke('POST', '/v2/orders/{id}/pause', pauseOrderRequest, headers); },
                    postponeEndDate: function (postponeEndDateRequest) {
                        return httpClient.invoke('PATCH', '/v2/orders/{id}', postponeEndDateRequest, headers);
                    },
                    queryOrders: function (queryOrdersRequest) { return httpClient.invoke('POST', '/v2/orders/query', queryOrdersRequest, headers); },
                    resumeOrder: function (v2OrdersResumeOrderRequest) {
                        return httpClient.invoke('POST', '/v2/orders/{id}/resume', v2OrdersResumeOrderRequest, headers);
                    },
                };
                service.cancelOrder.__http_method = 'POST';
                service.cancelOrder.__http_url = '/v2/orders/{id}/cancel';
                service.getAvailableOrderActions.__http_method = 'GET';
                service.getAvailableOrderActions.__http_url = '/v2/orders/{id}/available-owner-actions';
                service.getOrder.__http_method = 'GET';
                service.getOrder.__http_url = '/v2/orders/{id}';
                service.getOrdersStats.__http_method = 'GET';
                service.getOrdersStats.__http_url = '/v2/orders/stats';
                service.listOrders.__http_method = 'GET';
                service.listOrders.__http_url = '/v2/orders';
                service.markAsPaid.__http_method = 'POST';
                service.markAsPaid.__http_url = '/v2/orders/{id}/mark-as-paid';
                service.pauseOrder.__http_method = 'POST';
                service.pauseOrder.__http_url = '/v2/orders/{id}/pause';
                service.postponeEndDate.__http_method = 'PATCH';
                service.postponeEndDate.__http_url = '/v2/orders/{id}';
                service.queryOrders.__http_method = 'POST';
                service.queryOrders.__http_url = '/v2/orders/query';
                service.resumeOrder.__http_method = 'POST';
                service.resumeOrder.__http_url = '/v2/orders/{id}/resume';
                return service;
            };
        },
        OrdersService: function () {
            return function (headers) {
                var service = {
                    cancelOrder: function (v1OrdersCancelOrderRequest) {
                        return httpClient.invoke('POST', '/v1/orders/{id}/cancel', v1OrdersCancelOrderRequest, headers);
                    },
                    getCurrentMemberOrders: function (getCurrentMemberOrdersRequest) {
                        return httpClient.invoke('GET', '/v1/orders/my-orders', getCurrentMemberOrdersRequest, headers);
                    },
                    getOrder: function (v1OrdersGetOrderRequest) {
                        return httpClient.invoke('GET', '/v1/orders/{id}', v1OrdersGetOrderRequest, headers);
                    },
                    getOrdersStats: function (v1OrdersGetOrdersStatsRequest) {
                        return httpClient.invoke('GET', '/v1/orders/stats', v1OrdersGetOrdersStatsRequest, headers);
                    },
                    getPricePreview: function (v1OrdersGetPricePreviewRequest) {
                        return httpClient.invoke('GET', '/v1/orders/price-preview', v1OrdersGetPricePreviewRequest, headers);
                    },
                    getPurchasePreview: function (getPurchasePreviewRequest) {
                        return httpClient.invoke('POST', '/v1/orders/preview', getPurchasePreviewRequest, headers);
                    },
                    getSuspendableStatus: function (getSuspendableStatusRequest) {
                        return httpClient.invoke('GET', '/v1/orders/{id}/suspendable-status', getSuspendableStatusRequest, headers);
                    },
                    listOrders: function (v1OrdersListOrdersRequest) {
                        return httpClient.invoke('GET', '/v1/orders', v1OrdersListOrdersRequest, headers);
                    },
                    markOfflineOrderAsPaid: function (markOfflineOrderAsPaidRequest) {
                        return httpClient.invoke('POST', '/v1/orders/{id}/mark-as-paid', markOfflineOrderAsPaidRequest, headers);
                    },
                    purchasePlan: function (purchasePlanRequest) { return httpClient.invoke('POST', '/v1/orders', purchasePlanRequest, headers); },
                    purchasePlanOffline: function (purchasePlanOfflineRequest) {
                        return httpClient.invoke('POST', '/v1/orders/offline', purchasePlanOfflineRequest, headers);
                    },
                    resume: function (v1OrdersResumeOrderRequest) {
                        return httpClient.invoke('POST', '/v1/orders/{id}/resume', v1OrdersResumeOrderRequest, headers);
                    },
                    suspend: function (suspendOrderRequest) { return httpClient.invoke('POST', '/v1/orders/{id}/suspend', suspendOrderRequest, headers); },
                    updateValidFrom: function (updateValidFromRequest) {
                        return httpClient.invoke('PUT', '/v1/orders/{id}/valid-from', updateValidFromRequest, headers);
                    },
                    updateValidUntil: function (updateValidUntilRequest) {
                        return httpClient.invoke('PUT', '/v1/orders/{id}/valid-until', updateValidUntilRequest, headers);
                    },
                };
                service.cancelOrder.__http_method = 'POST';
                service.cancelOrder.__http_url = '/v1/orders/{id}/cancel';
                service.getCurrentMemberOrders.__http_method = 'GET';
                service.getCurrentMemberOrders.__http_url = '/v1/orders/my-orders';
                service.getOrder.__http_method = 'GET';
                service.getOrder.__http_url = '/v1/orders/{id}';
                service.getOrdersStats.__http_method = 'GET';
                service.getOrdersStats.__http_url = '/v1/orders/stats';
                service.getPricePreview.__http_method = 'GET';
                service.getPricePreview.__http_url = '/v1/orders/price-preview';
                service.getPurchasePreview.__http_method = 'POST';
                service.getPurchasePreview.__http_url = '/v1/orders/preview';
                service.getSuspendableStatus.__http_method = 'GET';
                service.getSuspendableStatus.__http_url = '/v1/orders/{id}/suspendable-status';
                service.listOrders.__http_method = 'GET';
                service.listOrders.__http_url = '/v1/orders';
                service.markOfflineOrderAsPaid.__http_method = 'POST';
                service.markOfflineOrderAsPaid.__http_url = '/v1/orders/{id}/mark-as-paid';
                service.purchasePlan.__http_method = 'POST';
                service.purchasePlan.__http_url = '/v1/orders';
                service.purchasePlanOffline.__http_method = 'POST';
                service.purchasePlanOffline.__http_url = '/v1/orders/offline';
                service.resume.__http_method = 'POST';
                service.resume.__http_url = '/v1/orders/{id}/resume';
                service.suspend.__http_method = 'POST';
                service.suspend.__http_url = '/v1/orders/{id}/suspend';
                service.updateValidFrom.__http_method = 'PUT';
                service.updateValidFrom.__http_url = '/v1/orders/{id}/valid-from';
                service.updateValidUntil.__http_method = 'PUT';
                service.updateValidUntil.__http_url = '/v1/orders/{id}/valid-until';
                return service;
            };
        },
        PlansService: function () {
            return function (headers) {
                var service = {
                    archivePlan: function (v1PlansArchivePlanRequest) {
                        return httpClient.invoke('POST', '/v1/plans/{id}/archive', v1PlansArchivePlanRequest, headers);
                    },
                    arrangePlans: function (v1PlansArrangePlansRequest) {
                        return httpClient.invoke('POST', '/v1/plans/arrange', v1PlansArrangePlansRequest, headers);
                    },
                    countPublicPlans: function (countPublicPlansRequest) {
                        return httpClient.invoke('POST', '/v1/plans/public/count', countPublicPlansRequest, headers);
                    },
                    createPlan: function (v1PlansCreatePlanRequest) {
                        return httpClient.invoke('POST', '/v1/plans', v1PlansCreatePlanRequest, headers);
                    },
                    getPlan: function (v1PlansGetPlanRequest) { return httpClient.invoke('GET', '/v1/plans/{id}', v1PlansGetPlanRequest, headers); },
                    getPlansStats: function (getPlansStatsRequest) { return httpClient.invoke('GET', '/v1/plans/stats', getPlansStatsRequest, headers); },
                    listPlans: function (v1PlansListPlansRequest) {
                        return httpClient.invoke('GET', '/v1/plans', v1PlansListPlansRequest, headers);
                    },
                    listPublicPlans: function (v1PlansListPublicPlansRequest) {
                        return httpClient.invoke('GET', '/v1/plans/public', v1PlansListPublicPlansRequest, headers);
                    },
                    makeNoPlanPrimary: function (makeNoPlanPrimaryRequest) {
                        return httpClient.invoke('POST', '/v1/plans/clear-primary', makeNoPlanPrimaryRequest, headers);
                    },
                    makePlanPrimary: function (v1PlansMakePlanPrimaryRequest) {
                        return httpClient.invoke('POST', '/v1/plans/{id}/make-primary', v1PlansMakePlanPrimaryRequest, headers);
                    },
                    queryPublicPlans: function (v1PlansQueryPublicPlansRequest) {
                        return httpClient.invoke('POST', '/v1/plans/public/query', v1PlansQueryPublicPlansRequest, headers);
                    },
                    setPlanVisibility: function (v1PlansSetPlanVisibilityRequest) {
                        return httpClient.invoke('PUT', '/v1/plans/{id}/visibility', v1PlansSetPlanVisibilityRequest, headers);
                    },
                    updatePlan: function (v1PlansUpdatePlanRequest) {
                        return httpClient.invoke('PATCH', '/v1/plans/{id}', v1PlansUpdatePlanRequest, headers);
                    },
                };
                service.archivePlan.__http_method = 'POST';
                service.archivePlan.__http_url = '/v1/plans/{id}/archive';
                service.arrangePlans.__http_method = 'POST';
                service.arrangePlans.__http_url = '/v1/plans/arrange';
                service.countPublicPlans.__http_method = 'POST';
                service.countPublicPlans.__http_url = '/v1/plans/public/count';
                service.createPlan.__http_method = 'POST';
                service.createPlan.__http_url = '/v1/plans';
                service.getPlan.__http_method = 'GET';
                service.getPlan.__http_url = '/v1/plans/{id}';
                service.getPlansStats.__http_method = 'GET';
                service.getPlansStats.__http_url = '/v1/plans/stats';
                service.listPlans.__http_method = 'GET';
                service.listPlans.__http_url = '/v1/plans';
                service.listPublicPlans.__http_method = 'GET';
                service.listPublicPlans.__http_url = '/v1/plans/public';
                service.makeNoPlanPrimary.__http_method = 'POST';
                service.makeNoPlanPrimary.__http_url = '/v1/plans/clear-primary';
                service.makePlanPrimary.__http_method = 'POST';
                service.makePlanPrimary.__http_url = '/v1/plans/{id}/make-primary';
                service.queryPublicPlans.__http_method = 'POST';
                service.queryPublicPlans.__http_url = '/v1/plans/public/query';
                service.setPlanVisibility.__http_method = 'PUT';
                service.setPlanVisibility.__http_url = '/v1/plans/{id}/visibility';
                service.updatePlan.__http_method = 'PATCH';
                service.updatePlan.__http_url = '/v1/plans/{id}';
                return service;
            };
        },
        PlansServiceV2: function () {
            return function (headers) {
                var service = {
                    archivePlan: function (v2PlansArchivePlanRequest) {
                        return httpClient.invoke('POST', '/v2/plans/{id}/archive', v2PlansArchivePlanRequest, headers);
                    },
                    arrangePlans: function (v2PlansArrangePlansRequest) {
                        return httpClient.invoke('POST', '/v2/plans/arrange', v2PlansArrangePlansRequest, headers);
                    },
                    clearPrimary: function (clearPrimaryRequest) {
                        return httpClient.invoke('POST', '/v2/plans/clear-primary', clearPrimaryRequest, headers);
                    },
                    createPlan: function (v2PlansCreatePlanRequest) {
                        return httpClient.invoke('POST', '/v2/plans', v2PlansCreatePlanRequest, headers);
                    },
                    getPlan: function (v2PlansGetPlanRequest) { return httpClient.invoke('GET', '/v2/plans/{id}', v2PlansGetPlanRequest, headers); },
                    getPlanStats: function (getPlanStatsRequest) { return httpClient.invoke('GET', '/v2/plans/stats', getPlanStatsRequest, headers); },
                    listPlans: function (v2PlansListPlansRequest) {
                        return httpClient.invoke('GET', '/v2/plans', v2PlansListPlansRequest, headers);
                    },
                    listPublicPlans: function (v2PlansListPublicPlansRequest) {
                        return httpClient.invoke('GET', '/v2/plans/public', v2PlansListPublicPlansRequest, headers);
                    },
                    makePlanPrimary: function (v2PlansMakePlanPrimaryRequest) {
                        return httpClient.invoke('POST', '/v2/plans/{id}/make-primary', v2PlansMakePlanPrimaryRequest, headers);
                    },
                    queryPublicPlans: function (v2PlansQueryPublicPlansRequest) {
                        return httpClient.invoke('POST', '/v2/plans/public/query', v2PlansQueryPublicPlansRequest, headers);
                    },
                    setPlanVisibility: function (v2PlansSetPlanVisibilityRequest) {
                        return httpClient.invoke('PUT', '/v2/plans/{id}/visibility', v2PlansSetPlanVisibilityRequest, headers);
                    },
                    updatePlan: function (v2PlansUpdatePlanRequest) {
                        return httpClient.invoke('PATCH', '/v2/plans/{plan.id}', v2PlansUpdatePlanRequest, headers);
                    },
                };
                service.archivePlan.__http_method = 'POST';
                service.archivePlan.__http_url = '/v2/plans/{id}/archive';
                service.arrangePlans.__http_method = 'POST';
                service.arrangePlans.__http_url = '/v2/plans/arrange';
                service.clearPrimary.__http_method = 'POST';
                service.clearPrimary.__http_url = '/v2/plans/clear-primary';
                service.createPlan.__http_method = 'POST';
                service.createPlan.__http_url = '/v2/plans';
                service.getPlan.__http_method = 'GET';
                service.getPlan.__http_url = '/v2/plans/{id}';
                service.getPlanStats.__http_method = 'GET';
                service.getPlanStats.__http_url = '/v2/plans/stats';
                service.listPlans.__http_method = 'GET';
                service.listPlans.__http_url = '/v2/plans';
                service.listPublicPlans.__http_method = 'GET';
                service.listPublicPlans.__http_url = '/v2/plans/public';
                service.makePlanPrimary.__http_method = 'POST';
                service.makePlanPrimary.__http_url = '/v2/plans/{id}/make-primary';
                service.queryPublicPlans.__http_method = 'POST';
                service.queryPublicPlans.__http_url = '/v2/plans/public/query';
                service.setPlanVisibility.__http_method = 'PUT';
                service.setPlanVisibility.__http_url = '/v2/plans/{id}/visibility';
                service.updatePlan.__http_method = 'PATCH';
                service.updatePlan.__http_url = '/v2/plans/{plan.id}';
                return service;
            };
        },
        PremiumService: function () {
            return function (headers) {
                var service = {
                    getPremiumStatus: function (getPremiumStatusRequest) {
                        return httpClient.invoke('GET', '/v1/premium/status', getPremiumStatusRequest, headers);
                    },
                };
                service.getPremiumStatus.__http_method = 'GET';
                service.getPremiumStatus.__http_url = '/v1/premium/status';
                return service;
            };
        },
        ProvisioningService: function () {
            return function (headers) {
                var service = {
                    getStatus: function (getStatusRequest) { return httpClient.invoke('GET', '/v1/provisioning/status', getStatusRequest, headers); },
                };
                service.getStatus.__http_method = 'GET';
                service.getStatus.__http_url = '/v1/provisioning/status';
                return service;
            };
        },
        SettingsService: function () {
            return function (headers) {
                var service = {
                    getSettings: function (getSettingsRequest) { return httpClient.invoke('GET', '/v2/settings', getSettingsRequest, headers); },
                    updateSettings: function (updateSettingsRequest) {
                        return httpClient.invoke('PATCH', '/v2/settings', updateSettingsRequest, headers);
                    },
                };
                service.getSettings.__http_method = 'GET';
                service.getSettings.__http_url = '/v2/settings';
                service.updateSettings.__http_method = 'PATCH';
                service.updateSettings.__http_url = '/v2/settings';
                return service;
            };
        },
        TaxService: function () {
            return function (headers) {
                var service = {
                    getTaxConfig: function (getTaxConfigRequest) { return httpClient.invoke('GET', '/v1/tax/config', getTaxConfigRequest, headers); },
                    setTaxConfig: function (setTaxConfigRequest) { return httpClient.invoke('PATCH', '/v1/tax/config', setTaxConfigRequest, headers); },
                };
                service.getTaxConfig.__http_method = 'GET';
                service.getTaxConfig.__http_url = '/v1/tax/config';
                service.setTaxConfig.__http_method = 'PATCH';
                service.setTaxConfig.__http_url = '/v1/tax/config';
                return service;
            };
        },
    };
};
exports.MembershipApi = MembershipApi;
exports.MembershipApi.__transport = 'http';
__exportStar(require("./types"), exports);
//# sourceMappingURL=http.js.map